export const SET_CHANNELS = 'SET_CHANNELS';
